import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "rounded-circle border d-flex flex-column align-items-center justify-content-center",
  style: {"height":"4rem","width":"4rem","border-width":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "rounded-circle border border-primary d-flex flex-column align-items-center justify-content-center",
    style: {"height":"3rem","width":"3rem","border-width":"10px"}
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-up text-primary fs-5" })
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "fw-semi-bold text-secondary" }, "Drag and Drop", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "- or -", -1)
const _hoisted_4 = { class: "col-sm-12 col-sm-6 col-md-6 col-lg-4 col-xl-3" }
const _hoisted_5 = { class: "row py-3 position-relative" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "col-12 position-relative upload-preview-item overflow-hidden"
}
const _hoisted_8 = {
  width: "320",
  controls: ""
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "fa-solid fa-image fa-10x"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "progress position-absolute w-75 bottom-0 start-50 translate-middle rounded-pill",
  style: {"height":"0.5rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "drop-target d-flex flex-column align-items-center justify-content-center",
      onDrop: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dropLink && _ctx.dropLink(...args)), ["prevent"])),
      onDragenter: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
      onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("a", {
        class: "btn btn-primary rounded-pill px-3",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.myfile.click()))
      }, "Choose File"),
      _createElementVNode("input", {
        class: "form-control d-none",
        id: "inputGroupFile04",
        type: "file",
        "aria-describedby": "inputGroupFileAddon04",
        "aria-label": "Upload",
        ref: "myfile",
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadOneFile($event)))
      }, null, 544)
    ], 32),
    _createVNode(_component_draggable, {
      class: "row",
      modelValue: _ctx.filesArray,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filesArray) = $event)),
      onEnd: _ctx.dragend,
      itemKey: "path"
    }, {
      item: _withCtx(({ element, index }) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("i", {
              class: "fa-solid fa-trash-alt text-danger position-absolute cursor-pointer",
              style: {"z-index":"50","top":"1.5rem","left":"0.5rem"},
              onClick: ($event: any) => (_ctx.deleteItem(index))
            }, null, 8, _hoisted_6),
            (element.path.search('.mp4') > -1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("video", _hoisted_8, [
                    _createElementVNode("source", {
                      src: _ctx.imageUrl(element.path),
                      type: "video/mp4"
                    }, null, 8, _hoisted_9),
                    _createTextVNode("Your browser does not support the video tag.")
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["col-12 position-relative upload-preview-item", {'bg-light':element.percent<100}])
                }, [
                  (element.percent<100)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _ctx.imageUrl(element.path),
                        style: {"width":"250px"}
                      }, null, 8, _hoisted_11)),
                  (element.percent<100)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", {
                          class: "progress-bar",
                          role: "progressbar",
                          style: _normalizeStyle(`width: ${element.percent}%; background-color:#919191;`)
                        }, null, 4)
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onEnd"])
  ], 64))
}